module.exports = __webpack_public_path__ + "img/57.a4aac19d.jpg";